exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".operationTable___1tTUr {\n  border-collapse: collapse;\n  border: none;\n  overflow: scroll;\n}\n\n.operationTable___1tTUr th {\n  padding: 0.5rem;\n}\n\n.operationTable___1tTUr td:nth-child(3), .operationTable___1tTUr td:nth-child(4), .operationTable___1tTUr th:nth-child(3), .operationTable___1tTUr th:nth-child(4) {\n  text-align: center;\n  padding-left: 1rem;\n  background-color: #F6F6F6;\n}\n", "", {"version":3,"sources":["/./studio/studio/style.scss"],"names":[],"mappings":"AAAA;EACE,0BAAyB;EACzB,aAAW;EACX,iBACF;CAAE;;AAEF;EACI,gBACJ;CAAE;;AAEF;EACI,mBAAkB;EAClB,mBAAkB;EAClB,0BACJ;CAAE","file":"style.scss","sourcesContent":[".operationTable {\r\n  border-collapse: collapse;\r\n  border:none;\r\n  overflow: scroll\r\n}\r\n\r\n.operationTable th {\r\n    padding: 0.5rem\r\n}\r\n\r\n.operationTable td:nth-child(3), .operationTable td:nth-child(4), .operationTable th:nth-child(3), .operationTable th:nth-child(4)  {\r\n    text-align: center;    \r\n    padding-left: 1rem;   \r\n    background-color: #F6F6F6\r\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"operationTable": "operationTable___1tTUr"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=2&sourceMap&localIdentName=[local]___[hash:base64:5]!./~/postcss-loader!./~/sass-loader?outputStyle=expanded&sourceMap!./studio/style.scss
 ** module id = 8
 ** module chunks = 0
 **/